import React from 'react';
import { GutResetLanding } from './gutReset/GutResetLanding';

export default () => {
  return <GutResetLanding />;
};
